import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import IEvent from '../../interfaces/IEvent';
import EventTimeline from './EventTimeline';

interface IProps {
  open: boolean;
  onClose: () => void;
  events: IEvent[];
  protocolNumber?: string;
  employeeName?: string;
}

const TITLE_ID = 'followup-events-dialog-title';

const FollowupEventsDialog = ({ open, onClose, events, protocolNumber, employeeName }: IProps) => {
  const subtitle = [protocolNumber, employeeName].filter(Boolean).join(' · ');
  const counterLabel = events.length === 1 ? '1 evento' : `${events.length} eventos`;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby={TITLE_ID}
      PaperProps={{ sx: { width: 420, maxWidth: '100%' } }}
    >
      <DialogTitle
        component="div"
        sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 1, paddingBottom: 1 }}
      >
        <Box sx={{ minWidth: 0 }}>
          <Typography id={TITLE_ID} sx={{ fontSize: 16, fontWeight: 500 }}>
            Eventos do documento
          </Typography>
          {subtitle && (
            <Typography sx={{ fontSize: 12, color: 'text.secondary' }}>{subtitle}</Typography>
          )}
        </Box>
        <IconButton aria-label="Fechar" size="small" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers sx={{ maxHeight: '60vh', overflowY: 'auto' }}>
        <EventTimeline events={events} />
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'space-between', paddingX: 3, paddingY: 1.5 }}>
        <Typography sx={{ fontSize: 12, color: 'text.secondary' }}>{counterLabel}</Typography>
        <Button variant="text" sx={{ textTransform: 'none' }} onClick={onClose}>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FollowupEventsDialog;
